var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00156 10.8V8.40002C6.00156 5.08632 8.68785 2.40002 12.0016 2.40002C15.3153 2.40002 18.0016 5.08632 18.0016 8.40002V10.8C19.327 10.8 20.4016 11.8745 20.4016 13.2V19.2C20.4016 20.5255 19.327 21.6 18.0016 21.6H6.00156C4.67608 21.6 3.60156 20.5255 3.60156 19.2V13.2C3.60156 11.8745 4.67608 10.8 6.00156 10.8ZM15.6016 8.40002V10.8H8.40156V8.40002C8.40156 6.4118 10.0133 4.80002 12.0016 4.80002C13.9898 4.80002 15.6016 6.4118 15.6016 8.40002Z",
    fill: "#3083DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/Locked.6397bcaa008680fe83dfdcc1e872cd83.svg";
export { ForwardRef as ReactComponent };